import script from "./MobileBottomNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileBottomNav.vue?vue&type=script&setup=true&lang=ts"

import "./MobileBottomNav.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__